/*
 *  -----------------------------------------------------------------------
 *    <copyright file="versions.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';

import { useTranslation, useGridCells } from 'hooks';
import { restructuredUpdatedCreatedBy } from '@utils-clean/update-users-array';
import Button from 'views/components/core/buttons/button';
import ExpandableGrid from 'views/components/core/expandable/grid/index';

import './styles.scss';

const PDFVersions = ({ data, actions, openNew, additionalColumns, spliceIndex, canEdit }: any) => {
    const { DateTimeCell, MaxLengthCell, StandardCell } = useGridCells();
    const [items, setItems] = useState(null);

    const { t } = useTranslation();

    useEffect(() => {
        let array = data?.sort((a: any, b: any) => new Date(b.created).getTime() - new Date(a.created).getTime()) ?? [];
        array = restructuredUpdatedCreatedBy(array);
        setItems(array);
    }, [data]);

    const columns = [
        {
            label: t('reports:generatedDate'),
            id: 'versions-date',
            field: 'created',
            minWidth: 220,
            filter: 'date',
            cells: { data: DateTimeCell('DD-MMM-YYYY HH:mm UTC') },
        },
        {
            field: '_createdByString',
            id: 'versions-created-by',
            label: t('reports:generatedBy'),
            minWidth: 230,
        },
        {
            field: 'status',
            id: 'versions-status',
            label: t('ra:status'),
            minWidth: 230,
            cells: { data: StandardCell(true) },
        },
        {
            field: 'comments',
            id: 'versions-comments',
            label: t('ra:comments'),
            minWidth: 230,
            cells: { data: MaxLengthCell(150) },
        },
        {
            field: 'recordId',
            id: 'versions-id',
            showByDefault: false,
            label: 'ID',
            filter: 'numeric',
            minWidth: 140,
        },
    ];

    if (additionalColumns && spliceIndex !== undefined) columns.splice(spliceIndex, 0, ...additionalColumns);

    return (
        <div className="report-wrapper">
            <div className="header">
                <p className="title">{t('reports:reportVersions')}</p>
                <Button
                    id="new-report"
                    className="new-btn-pdf-report"
                    disabled={!canEdit}
                    onClick={() => {
                        openNew(true);
                    }}
                >
                    <FontAwesomeIcon icon={['far', 'layer-plus']} className="layer-plus" />
                </Button>
            </div>
            <div className="content">
                <ExpandableGrid
                    customKey="versions-grid"
                    id="versionsGrid"
                    items={items}
                    rowActions={actions}
                    groupable={false}
                    showPager
                    scrollable="scrollable"
                    reorderable
                    pageable={false}
                    resizable
                    addScroll={false}
                    options={{
                        allowExcelExport: false,
                        allowExpandCollapseAll: false,
                        useFilterChips: true,
                    }}
                    detail={null}
                    columns={columns}
                />
            </div>
        </div>
    );
};

export default PDFVersions;
